

























































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import StoreSuketMcuCpnsGol3 from "@/store/modules/SuketMcuCpnsGol3";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storeDokter } from "@/store/modules/dokter";
import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    pdf
  }
})
export default class SuketMcuCpnsGol3TabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  // MCU CPNS dapat diterbitkan di poli MCU/Penyakit Dalam mana pun → izinkan
  // di seluruh unit; kunci read-only tetap dari edit-window halaman (48 jam).
  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.McuCpnsGol3);
  suketStore = StoreSuketMcuCpnsGol3;
  suketCategory = EnSuketCategory.McuCpnsGol3;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  alamat_type = "ktp";

  peserta: any = {
    nama: this.pasien.nama,
    nip: null,
    pekerjaan: "CPNS",
    jabatan: null,
    golongan: "III",
    alamat: this.pasien.alamat
  };

  permintaan: any = {
    atas_permintaan: null,
    nomor_surat: null,
    tanggal_surat: null
  };

  kesimpulan: any = {
    opsi: null,
    catatan: null
  };

  dasar_hukum: any = {
    sk_menkes: "HK.01.07/Menkes/2145/2023",
    tanggal_sk: "17 November 2023",
    permenkes: "143/MENKES/Per/VII/77",
    tanggal_permenkes: "1 Juli 1977"
  };

  openPanels = [0, 1, 2];
  saving = false;
  loadedRatio = 0;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  golonganOptions = ["I", "II", "III", "IV"];

  kesimpulanOptions = [
    {
      value: "a",
      text: "Memenuhi syarat untuk semua jenis pekerjaan pada umumnya"
    },
    {
      value: "b",
      text: "Memenuhi syarat untuk jenis pekerjaan tertentu"
    },
    {
      value: "c",
      text: "Dapat diterima dengan bersyarat untuk (a) atau (b) tersebut diatas"
    },
    {
      value: "d",
      text:
        "Untuk sementara belum memenuhi syarat kesehatan dan memerlukan pengobatan/perawatan dan ujian kesehatan perlu diulang setelah selesai pengobatan/perawatan atau ditolak sementara"
    },
    {
      value: "e",
      text:
        "Tidak memenuhi syarat untuk menjalankan tugas sebagai Pegawai Negeri Sipil"
    }
  ];

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get catatanRules() {
    if (this.kesimpulan.opsi && this.kesimpulan.opsi !== "a") {
      return [
        v => (!!v && v.length >= 50) || "Wajib diisi minimal 50 karakter"
      ];
    }
    return [];
  }

  get alamatOptions() {
    const opts = [
      { id: "ktp", name: this.pasien.alamat, category: "Alamat KTP" }
    ];
    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili"
      });
    }
    return opts;
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.McuCpnsGol3, this.dataSuket.id)
      : null;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        peserta: this.peserta,
        permintaan: this.permintaan,
        kesimpulan: this.kesimpulan,
        dasar_hukum: this.dasar_hukum,
        jabatan_penandatangan: "Ketua TPK"
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  mounted() {
    this.hydrate(this.dataSuket);
  }

  hydrate(d: any) {
    this.register_id = d?.register_id || this.register;
    this.pasien_rm = d?.pasien_rm || this.pasien.rm;
    this.unit_id = d?.unit_id || this.user.unit_id;
    this.surat_date = d?.surat_date || new Date();
    this.signee_user_id = d?.signee_user_id || this.user.id;
    this.creator_user_id = d?.creator_user_id || this.user.id;
    this.alamat_type = d?.content?.alamat_type || "ktp";

    const c = d?.content;
    if (c) {
      this.peserta = {
        ...this.peserta,
        ...(c.peserta || {})
      };
      this.permintaan = { ...this.permintaan, ...(c.permintaan || {}) };
      this.kesimpulan = { ...this.kesimpulan, ...(c.kesimpulan || {}) };
      this.dasar_hukum = { ...this.dasar_hukum, ...(c.dasar_hukum || {}) };
    } else {
      // Default peserta.nama dan alamat dari data pasien bila belum ada.
      this.peserta.nama = this.pasien.nama;
      this.peserta.alamat = this.pasien.alamat;
    }
  }

  @Watch("alamat_type")
  watchAlamatType(val: string) {
    if (val === "domisili" && this.pasien.alamat_domisili) {
      this.peserta.alamat = this.pasien.alamat_domisili;
    } else {
      this.peserta.alamat = this.pasien.alamat;
    }
  }

  @Watch("dataSuket")
  changeDataSuket(val: any) {
    this.hydrate(val);
  }

  @Watch("loadedRatio")
  changeLoadedRatio() {
    // noop — keep parity with sibling suket cards
  }

  save() {
    if (this.saving) return;

    // Honesty guard (mirror backend): kesimpulan wajib; bila ≠ (a) wajib
    // justifikasi ≥ 50 karakter.
    if (!this.kesimpulan.opsi) {
      appModule.sendErrorAlert("Pilihan kesimpulan wajib diisi");
      return;
    }
    if (
      this.kesimpulan.opsi !== "a" &&
      (this.kesimpulan.catatan || "").length < 50
    ) {
      appModule.sendErrorAlert(
        "Justifikasi klinis wajib diisi minimal 50 karakter bila kesimpulan bukan opsi (a)"
      );
      return;
    }

    this.saving = true;
    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        if (this.canSign) {
          this.showSignatureModal();
        }
        appModule.NoticeDelay("Berhasil Simpan");
        this.close();
        StoreSuketMcuCpnsGol3.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.expandInput = false;
  }
}
